<ion-header no-border>
  <ion-toolbar>
    <ion-buttons slot="start">
      <ion-back-button mode="md" defaultHref="/reports"></ion-back-button>
    </ion-buttons>
    <ion-title> Inventory Report </ion-title>
  </ion-toolbar>
</ion-header>

<ion-content>
  <salonmonster-load-mask *ngIf="isLoading"></salonmonster-load-mask>

  <div margin-top *ngIf="!isLoading && !errorOccurredWhileLoadingStats">
    <p-table
      #dt
      styleClass="sticky-table"
      [columns]="cols"
      [value]="stats"
      sortMode="multiple"
      [globalFilterFields]="['name','size','brand','category', 'supplier']"
    >
      [responsive]="true">
      <ng-template pTemplate="caption">
        <div class="ui-helper-clearfix" style="text-align: right">
          <span class="export">Export to:</span>
          <ion-button
            fill="outline"
            (click)="exportExcel()"
            style="margin-right: 0.5em"
            >Excel</ion-button
          >
          <ion-button fill="outline" (click)="exportPdf()"> PDF </ion-button>
        </div>
      </ng-template>
      <ng-template pTemplate="header" let-columns>
        <tr>
          <th *ngFor="let col of columns">{{col.header}}</th>
        </tr>
        <tr>
          <th *ngFor="let col of columns" [ngSwitch]="col.field">
            <input
              class="sm-input-border"
              *ngSwitchCase="'name'"
              pInputText
              type="text"
              (input)="dt.filter($any($event.target).value, col.field, 'contains')"
            />
            <input
              class="sm-input-border"
              *ngSwitchCase="'size'"
              pInputText
              type="text"
              (input)="dt.filter($any($event.target).value, col.field, 'contains')"
            />
            <p-dropdown
              *ngSwitchCase="'brand'"
              [options]="brands"
              [style]="{'width':'100%'}"
              (onChange)="dt.filter($any($event).value, col.field, 'equals')"
            ></p-dropdown>
            <p-dropdown
              *ngSwitchCase="'category'"
              [options]="categories"
              [style]="{'width':'100%'}"
              (onChange)="dt.filter($any($event.value), col.field, 'equals')"
            ></p-dropdown>
            <p-dropdown
              *ngSwitchCase="'supplier'"
              [options]="suppliers"
              (onChange)="dt.filter($any($event).value, col.field, 'equals')"
            ></p-dropdown>
          </th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-stat let-columns="columns">
        <tr>
          <td *ngFor="let col of columns">{{stat[col.field]}}</td>
        </tr>
      </ng-template>
      <ng-template pTemplate="footer">
        <tr>
          <td><strong>Total</strong></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td>{{ totalQuantity }}</td>
          <td>{{ totalCost }}</td>
          <td>{{ totalRetailPrice }}</td>
        </tr>
      </ng-template>
    </p-table>
  </div>
</ion-content>
